import { BaseApi } from '@/main/baseApi';
import { NAME as uctenky } from '@/modules/uctenky/constants';

import { DMS_MODULE, NAME } from './constants';

class DokladProvider extends BaseApi {
	getSazby(dokladId: number, dokladNaplnFakturaci: number | null) {
		return this.fetch(`/${uctenky}/${DMS_MODULE}/DobropisVrubopis`, { dokladId, dokladNaplnFakturaci });
	}

	tvorbaFaktury(doklad: any) {
		return this.postPdf(`/${uctenky}/${DMS_MODULE}/TvorbaFaktury?nahled=${false}`, doklad);
	}

	pripravaFakturace(doklady: any, zakazkaId: number | null, dokladId: number | null, dokladNaplnFakturaci: number | null) {
		return this.post(`/${uctenky}/${DMS_MODULE}`,
			{
				ZakazkaId: zakazkaId,
				DokladId: dokladId,
				DokladNaplnFakturaci: dokladNaplnFakturaci,
				DobropisVrubopisDTOs: doklady,
			});
	}
}
export const apiProvider = new DokladProvider(DMS_MODULE, NAME);
